import { render, staticRenderFns } from "./customizeNotification.vue?vue&type=template&id=1aecb205"
import script from "./customizeNotification.vue?vue&type=script&lang=js"
export * from "./customizeNotification.vue?vue&type=script&lang=js"
import style0 from "./customizeNotification.vue?vue&type=style&index=0&id=1aecb205&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports